import React from 'react';
import { TreeEvergreenIcon } from '@phosphor-icons/react';
import type { SavedAIDesign } from '../../../../../store/oneButtonStore';

interface ActiveDesignBadgeProps {
    activeAIDesignId: string | null;
    activeSubScenarioId: string | null;
    savedAIDesigns: SavedAIDesign[];
    isDashboardOpen: boolean;
}

export const ActiveDesignBadge: React.FC<ActiveDesignBadgeProps> = ({
    activeAIDesignId,
    activeSubScenarioId,
    savedAIDesigns,
    isDashboardOpen,
}) => {
    if (!activeAIDesignId || isDashboardOpen) return null;
    const design = savedAIDesigns.find((d) => d.aiDesignId === activeAIDesignId);
    if (!design) return null;
    const sub = activeSubScenarioId
        ? (design.treeCutSubScenarios ?? []).find((s) => s.id === activeSubScenarioId)
        : null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 100,
                right: 16,
                zIndex: 9999,
                background: 'rgba(15,23,42,0.92)',
                backdropFilter: 'blur(12px)',
                border: '1px solid rgba(96,165,250,0.4)',
                borderRadius: 14,
                padding: '12px 18px',
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                minWidth: 220,
                boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
            }}
        >
            <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(96,165,250,0.85)' }}>Active Design</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'rgba(248,250,252,0.98)' }}>{design.label}</span>
            <span style={{ fontSize: 11, color: 'rgba(148,163,184,0.85)' }}>{Math.round(design.productionW).toLocaleString()} W · {design.modules} modules</span>
            {sub && (
                <span style={{ fontSize: 11, color: 'rgba(74,222,128,0.9)', marginTop: 2 }}>
                    <TreeEvergreenIcon size={12} weight="duotone" style={{ verticalAlign: -2, marginRight: 4 }} />
                    {sub.treeLabel || `${sub.treeIds.length} tree(s)`} · +{Math.round(sub.gainW).toLocaleString()} W
                </span>
            )}
        </div>
    );
};
